import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        totalUsers: 0,
        regularUsers: 0,
        totalAdmins: 0,
        totalOrders: 0,
        activeOrders: 0,
        totalFranchises: 0,
        totalRestaurantFranchises: 0,
        totalTagFranchises: 0,
        totalRevenue: 0,
        totalTags: 0,
        activeTags: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAdminData();
    }, []);

    const fetchAdminData = async () => {
        try {
            setLoading(true);
            const response = await api.get('/admin/dashboard');
            if (response.data.success) {
                const d = response.data.data || {};
                setStats({
                    totalUsers: d.totalUsers ?? 0,
                    regularUsers: d.regularUsers ?? 0,
                    totalAdmins: d.totalAdmins ?? 0,
                    totalOrders: d.totalOrders ?? 0,
                    activeOrders: d.activeOrders ?? 0,
                    totalFranchises: d.totalFranchises ?? 0,
                    totalRestaurantFranchises: d.totalRestaurantFranchises ?? 0,
                    totalTagFranchises: d.totalTagFranchises ?? 0,
                    totalRevenue: typeof d.totalRevenue === 'number' ? d.totalRevenue : Number(d.totalRevenue) || 0,
                    totalTags: d.totalTags ?? 0,
                    activeTags: d.activeTags ?? d.totalTags ?? 0
                });
            }
        } catch (error) {
            console.error('Error fetching admin data:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="admin-loading">Loading dashboard...</div>;
    }

    return (
        <div className="admin-dashboard">
            <header className="dashboard-header">
                <h2>Dashboard Overview</h2>
            </header>

            <div className="stats-grid">
                <div className="stat-card primary" onClick={() => navigate('/admin/users')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">👥</div>
                    <div className="stat-info">
                        <h3>Total Users</h3>
                        <p className="stat-value">{stats.totalUsers}</p>
                        <p className="stat-sub">{stats.regularUsers} with role user · {stats.totalAdmins} admins</p>
                    </div>
                </div>
                <div className="stat-card success" onClick={() => navigate('/admin/qrcodes')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🏷️</div>
                    <div className="stat-info">
                        <h3>Active tags</h3>
                        <p className="stat-value">{stats.activeTags}</p>
                        <p className="stat-sub">{stats.totalTags} total in system</p>
                    </div>
                </div>
                <div className="stat-card warning" onClick={() => navigate('/admin/franchises')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🏪</div>
                    <div className="stat-info">
                        <h3>Franchises</h3>
                        <p className="stat-value">{stats.totalFranchises}</p>
                        <p className="stat-sub">{stats.totalTagFranchises} tags · {stats.totalRestaurantFranchises} restaurant</p>
                    </div>
                </div>
                <div className="stat-card info" onClick={() => navigate('/admin/orders')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">₹</div>
                    <div className="stat-info">
                        <h3>Revenue (delivered)</h3>
                        <p className="stat-value">₹{stats.totalRevenue.toLocaleString('en-IN')}</p>
                        <p className="stat-sub">{stats.totalOrders} orders · {stats.activeOrders} in progress</p>
                    </div>
                </div>
            </div>

            <div className="dashboard-grid">
                <div className="card scroll-card">
                    <div className="card-header">
                        <h3>Recent Activity</h3>
                    </div>
                    <div className="activity-list">
                        {[1, 2, 3].map(i => (
                            <div key={i} className="activity-item">
                                <div className="activity-dot"></div>
                                <div className="activity-details">
                                    <p className="activity-title">New user registration</p>
                                    <p className="activity-time">Just now</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="card actions-card">
                    <div className="card-header">
                        <h3>Quick Actions</h3>
                    </div>
                    <div className="action-buttons">
                        <button className="action-btn" onClick={() => navigate('/admin/users')}>
                            <span className="btn-icon">➕</span>
                            <span>Add New User</span>
                        </button>
                        <button className="action-btn" onClick={() => navigate('/admin/franchises')}>
                            <span className="btn-icon">🏪</span>
                            <span>Add Franchise</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
